import { render, staticRenderFns } from "./ButtonControl.vue?vue&type=template&id=3135204c&scoped=true&"
import script from "./ButtonControl.vue?vue&type=script&lang=js&"
export * from "./ButtonControl.vue?vue&type=script&lang=js&"
import style0 from "./ButtonControl.vue?vue&type=style&index=0&id=3135204c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135204c",
  null
  
)

export default component.exports